import api from "./axios";

export async function fetchOwnerBookingPage(params = {}) {
  const {
    view = "scheduled",
    vehicleReg,
    driverId,
    historyStatus = "all",
    page = 0,
    size = 25,
    sortKey = "date",
    sortDir = "desc",
  } = params;

  const { data } = await api.get("/owners/bookings", {
    params: {
      view,
      vehicleReg: vehicleReg && vehicleReg !== "all" ? vehicleReg : undefined,
      driverId: driverId && driverId !== "all" ? driverId : undefined,
      historyStatus,
      page,
      size,
      sortKey,
      sortDir,
    },
  });

  return data || {
    items: [],
    page: 0,
    size,
    totalElements: 0,
    totalPages: 0,
  };
}

export async function fetchOwnerBookingStats() {
  const { data } = await api.get("/owners/bookings/stats");
  return data || {
    requests: 0,
    todaysTrips: 0,
    scheduled: 0,
    completed: 0,
    cancelledOrMissed: 0,
  };
}
